import { ItemOffer } from "@/types";
import { atom } from "jotai";

const itemOffersAtom = atom<ItemOffer[]>([])

export default itemOffersAtom
